module.exports = ":host {\n  color: #fe4343;\n  display: block;\n  font-size: 14px;\n  font-weight: 100;\n}"